import {
  DataArray,
  UpdateIconButton,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@compass/core";

import { ListBeProperty } from "components";
import { DistrictListResource, FileCategoryListDto, Permission, PermissionAction, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { fileCategoryPageRoute } from "../FileCategoryPage/FileCategoryPage";

export const FileCategoryTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  fileCategories: FileCategoryListDto[];
  setFileCategories: (fileCategories: FileCategoryListDto[]) => void;
  resource: DistrictListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "7%"}}>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<FileCategoryListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<FileCategoryListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.fileCategories.map((fileCategory) => (
            <TableRow
              key={fileCategory.id}
              onClick={() =>
                navigate(
                  fileCategoryPageRoute.getPath({
                    id: fileCategory.id,
                    crudMode: "view",
                    screenType: "dialog"
                  })
                )
              }
            >
              <TableCell>{fileCategory.id}</TableCell>
              <TableCell>{fileCategory.name}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                    onClick={() =>
                      navigate(
                        fileCategoryPageRoute.getPath({
                          id: fileCategory.id,
                          crudMode: "edit",
                          screenType: "dialog"
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
